import { render, staticRenderFns } from "./addData.vue?vue&type=template&id=39b6676c&scoped=true&"
import script from "./addData.vue?vue&type=script&lang=js&"
export * from "./addData.vue?vue&type=script&lang=js&"
import style0 from "./addData.vue?vue&type=style&index=0&id=39b6676c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6676c",
  null
  
)

export default component.exports